import { createSlice } from "@reduxjs/toolkit";
import { ApiStatus } from "../../types/api/status";
import { RootState } from "../store";
import { searcherType, Product, FilterProducts } from "../../types/slices/searcherType";
import { Subcategory } from "../../types/slices/subcategoryType";
import { SpecificAttribute } from "../../types/slices/specificAttributesType";
import { ProductAttribute } from "../../types/slices/productAttributesType";
import { ClientAdress } from "../../types/slices/clientAdressType";

const initialState: searcherType = {
    status: ApiStatus.FETCHED,
    selectedCustomer: null,
    selectedAddress: null,
    selectedSalesman: null,
    selectedPriceList: null,
    selectedCategory: null,
    selectedSubCategory: null,
    selectedSpecificAttribute: null,
    selectedUseAttribute: null,
    filterProducts: {} as FilterProducts,
    products: [],
    productSelected: {} as Product,
    errorMessage: undefined,
    dataSearch: []
}

const searcherSlice = createSlice({
    name: 'searcherSlice',
    initialState,
    reducers: {
        onFetchProducts(state, { payload }: { payload: Product[] }) {
            state.status = ApiStatus.FETCHED
            state.products = payload
            state.errorMessage = undefined
        },
        onSetSelectedCustomer(state, { payload }: { payload: any }) {
            state.selectedCustomer = payload
        },
        onSetSelectedSalesman(state, { payload }: { payload: any }) {
            state.selectedSalesman = payload
        },
        onSetSelectedPriceList(state, { payload }: { payload: any }) {
            state.selectedPriceList = payload
        },
        changeStatus(state, { payload }: { payload: ApiStatus }) {
            state.status = payload
        },
        onSetSelectedCategory(state, { payload }: { payload: any }) {
            state.selectedCategory = payload
        },
        onSetSelectedSubCategory(state, { payload }: { payload: Subcategory | null }) {
            state.selectedSubCategory = payload
        },
        onSetSelectedSpecificAttribute(state, { payload }: { payload: SpecificAttribute }) {
            state.selectedSpecificAttribute = payload
        },
        onSetSelectedUseAttribute(state, { payload }: { payload: ProductAttribute }) {
            state.selectedUseAttribute = payload
        },
        onSetDataSearch(state, { payload }: { payload: any }) {
            state.dataSearch = payload
        },
        onSetFilterProducts(state, { payload }: { payload: FilterProducts }) {
            state.filterProducts = payload
        },
        onSetSelectedAddress(state, { payload }: { payload: ClientAdress | null }) {
            state.selectedAddress = payload
        },
    }
})

export const selectSearcherState = (state: RootState) => state.searcherSlice
export default searcherSlice.reducer

export const {
    onFetchProducts,
    onSetSelectedCustomer,
    onSetSelectedSalesman,
    onSetSelectedPriceList,
    changeStatus,
    onSetSelectedCategory,
    onSetSelectedSubCategory,
    onSetSelectedSpecificAttribute,
    onSetSelectedUseAttribute,
    onSetDataSearch,
    onSetFilterProducts,
    onSetSelectedAddress
} = searcherSlice.actions